// extracted by mini-css-extract-plugin
module.exports = {"formDivider":"PaymentForm_formDivider__1PC7h","inputLabel":"PaymentForm_inputLabel__1QJkd","cardsWrapper":"PaymentForm_cardsWrapper__3U_8I"};